export const initStateCategoriesDocuments = (
   Object.assign({
      categories_with_type : [],
      data                 : [],
      document_name        : '',
      actionForm           : false,
      categoryDocumentId   : ''
   })
);